import { Box, Typography } from "@mui/material";

// label on the left, value on the right: the summary lines under swap and liquidity forms
const DetailRow = ({ label, value }) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1.5 }}>
    <Typography variant="body2" component="span" sx={{ color: "text.secondary" }}>
      {label}
    </Typography>
    <Typography variant="body2" component="span" sx={{ textAlign: "right" }}>
      {value}
    </Typography>
  </Box>
);

export default DetailRow;
